import { IAppContext } from 'App/AppContext';
import { sortOnArray, sortOnString , sortOnCode, sortOnNumber } from 'utils/sorting';
import { IColumn } from '@fluentui/react';

import Asset from 'models/asset/asset';
import { Owner } from 'models/owner';

export const getAscendingSortValueKey = (a: Asset, b: Asset, key: string, appContext: IAppContext): number => {
  if (key === 'code') return sortOnCode(a.code, b.code);
  if (key === 'name') return sortOnString(a.name, b.name);
  if (key === 'listtype') return sortOnNumber(a.listId, b.listId);
  if (key === 'state') return a.state - b.state;
  if (key === 'type') return a.type - b.type;
  if (key === 'tags') return sortOnArray(a.tagIds, b.tagIds);
  if (key === 'classifications') return sortOnArray(a.classifications, b.classifications);
  if (key === 'containers') return sortOnArray(a.containers, b.containers);
  if (key === 'location') return sortOnString(a.location?.value, b.location?.value);
  if (key === 'owner') {
    return Owner.sort(a, b, appContext);
  }
  if (key === 'standards') return sortOnArray(a.normIds, b.normIds);
  if (key === 'permissions') {
    const a1 = appContext.globalDataCache.authSchemas.get(a.authSchemaId);
    const b1 = appContext.globalDataCache.authSchemas.get(b.authSchemaId);

    return sortOnString(a1.name, b1.name);
  }

  return 1;
};

export const copyAndSortAssets = (
  items: Asset[],
  column: IColumn,
  isSortedDescending: boolean | undefined,
  appContext: IAppContext,
): Asset[] => {
  const key = column.key;

  return items.slice().sort((a: Asset, b: Asset) => {
    const tmp = getAscendingSortValueKey(a, b, key, appContext);

    return isSortedDescending ? -tmp : tmp;
  });
};
